import * as base from './base';
import * as types from 'constants/action-types';
import * as api from 'api';

export const fetchOrders = (q, page = 1, perPage, sortOpts, extraFilters) =>
  base.fetchRecords(api.fetchOrders, setOrders, q, page, perPage, sortOpts, extraFilters);

export const setOrders = (records, currentPage, pageCount, totalCount, itemsPerPage) => ({
  type: types.SET_ORDERS,
  records,
  currentPage,
  pageCount,
  totalCount,
  itemsPerPage,
});

export const fetchOrder = (recordId) => (dispatch) =>
  api.fetchOrder(recordId).then((response) => {
    dispatch(setCurrentOrder(recordId, response.record));
  });

export const setCurrentOrderPage = (page) => ({
  type: types.SET_CURRENT_ORDER_PAGE,
  page,
});

export const setCurrentOrder = (recordId, recordData) => ({
  type: types.SET_CURRENT_ORDER,
  recordId,
  recordData,
});

export const clearOrdersAfterPage = (page) => ({
  type: types.CLEAR_ORDERS_AFTER_PAGE,
  page,
});
